// 工具函数：统一租房搜索逻辑
export async function rentalSearch(searchText, navigate, setLoading) {
  if (!searchText.trim()) return;
  if (setLoading) setLoading(true);
  const GOOGLE_MAPS_API_KEY = 'AIzaSyABl8lts6BmCwMfw-cVqa1Xy3xDxoEJhUg';
  try {
    const trimmed = searchText.trim();
    // 先查后端，看是否能直接按名称/地址匹配到房源
    const apiBase = (await import('./api')).API_BASE_URL;
    const res = await fetch(`${apiBase}/properties/rentals/?search=${encodeURIComponent(trimmed)}`);
    const data = await res.json();
    const results = Array.isArray(data) ? data : (data.results || []);

    if (results.length > 0 && results[0].latitude && results[0].longitude) {
      // 有直接匹配的房源，用第一个结果的坐标定位地图
      const { latitude: lat, longitude: lng } = results[0];
      navigate(`/rentals?lat=${lat}&lng=${lng}&search=${encodeURIComponent(trimmed)}`);
      return;
    }

    // 没有名称匹配，fallback 到 Geocoding（按地点搜索）
    const address = encodeURIComponent(trimmed);
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${GOOGLE_MAPS_API_KEY}`;
    const geoResp = await fetch(url);
    const geoData = await geoResp.json();
    if (geoData.status === 'OK' && geoData.results.length > 0) {
      const loc = geoData.results[0].geometry.location;
      navigate(`/rentals?lat=${loc.lat}&lng=${loc.lng}`);
    } else {
      navigate(`/rentals?search=${encodeURIComponent(trimmed)}`);
    }
  } catch (err) {
    navigate(`/rentals?search=${encodeURIComponent(searchText.trim())}`);
  } finally {
    if (setLoading) setLoading(false);
  }
} 